import React from 'react';
import { useTranslation } from 'react-i18next';
import ConfigFormPopup from '../../../shared/popup/config-form-popup';

function ViewAttachment(props: any) {
  const { t } = useTranslation();

  const name = props.attachmentFile ? props.attachmentFile.name : '';
  const description = props.attachmentFile ? props.attachmentFile.description : '';
  const size = props.attachmentFile ? props.attachmentFile.size : '';
  const owner = props.attachmentFile ? props.attachmentFile.uid : '';

  return (
    <div>
      <ConfigFormPopup
        isOpen={props.isOpen}
        onClose={props.onClose}
        onSubmit={props.onSubmit}
        currentStateMode={props.currentStateMode}
        hasPrivilegesToEdit={false}
        isFirstChildLeftOfEditButton={props.isFirstChildLeftOfEditButton}
        fieldDirty={props.fieldDirty}
        getTitle={props.getTitle}
        width={props.width}
      >
        <p>{t('warrant.attachment.view.fileName')} {name}</p>
        <p>{t('warrant.attachment.view.description')} {description} </p>
        <p>{t('warrant.attachment.view.size')} {size}</p>
        <p>{t('warrant.attachment.view.owner')} {owner}</p>
      </ConfigFormPopup>
    </div>
  );
}

export default ViewAttachment;
